import React, { useState } from 'react';
import { string, shape, func } from 'prop-types';
import { CaretIcon } from '@axiom/ui';

import { formatDataTestId } from '../../utils/data-test-util';

import {
  SavedSearchesMenuItem,
  SavedSearchesItemFilterContainer,
  SavedSearchesItemTitle,
  SavedSearchesPlayWrapper,
  SavedSearchesItemWrapper,
} from './OpportunityFilterSavedSearchesStyles';

export const OpportunityFilterSavedSearchesItem = ({
  userFilter,
  handleFilterLoad,
  handleRenderFilter,
}) => {
  const [showFilters, setShowFilters] = useState(false);

  const handleToggleFilter = () => setShowFilters(!showFilters);

  const { filters: savedFilters, ...otherData } = userFilter;
  const { salesCloseDate, ...filters } = savedFilters;

  if (salesCloseDate?.start) {
    filters.salesCloseDateStart = salesCloseDate.start;
  }
  if (salesCloseDate?.end) {
    filters.salesCloseDateEnd = salesCloseDate.end;
  }

  const userFilters = {
    ...otherData,
    filters,
  };

  return (
    <>
      <SavedSearchesItemWrapper data-test={userFilters.name}>
        <SavedSearchesItemTitle onClick={() => handleFilterLoad(userFilters)}>
          {userFilters.name}
        </SavedSearchesItemTitle>
        <SavedSearchesPlayWrapper
          onClick={() => handleFilterLoad(userFilters)}
          data-test={formatDataTestId('showSavedResults')}
        >
          <CaretIcon direction="right" height={13} />
        </SavedSearchesPlayWrapper>
        <SavedSearchesMenuItem
          onClick={handleToggleFilter}
          expanded={showFilters}
          data-test={formatDataTestId('searchEllipsis')}
        />
      </SavedSearchesItemWrapper>
      {!!showFilters && (
        <SavedSearchesItemFilterContainer
          data-test={formatDataTestId('savedSearchForm')}
        >
          {handleRenderFilter(userFilters)}
        </SavedSearchesItemFilterContainer>
      )}
    </>
  );
};

OpportunityFilterSavedSearchesItem.propTypes = {
  handleFilterLoad: func.isRequired,
  handleRenderFilter: func.isRequired,
  userFilter: shape({
    name: string.isRequired,
    id: string.isRequired,
  }).isRequired,
};
